import { CustomLink, DateDistanceDisplay } from '@ygtechnologies/bygr-frontend-component-library';
import { FlatCard } from '@/components/FlatCard';
import React from 'react';
import { getBygrData, getBygrVisitData, getNewProjects } from '@/services/statistics';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import theme from './BygrStatisticsDashboard.module.scss';
import PrimaryCard from './PrimaryCard';
import StatisticsSharedCards from './StatisticsSharedCards';

interface BygrStatisticsDashboardProps {}

const BygrStatisticsDashboard: React.FC<BygrStatisticsDashboardProps> = () => {
    const [data] = useAsyncStateWithIsLoading(() => getBygrData(), [], null);
    const [visit] = useAsyncStateWithIsLoading(() => getBygrVisitData(), [], null);
    const [newProjects] = useAsyncStateWithIsLoading(() => getNewProjects(), [], null);
    return (
        <div className={theme.page}>
            <div className={theme.cardColumns}>
                <PrimaryCard title={'Rubus data'} loading={!data}>
                    {() => (
                        <>
                            <PrimaryCard.Row label="Users">{data?.users}</PrimaryCard.Row>
                            <PrimaryCard.Row label="Units">{data?.units}</PrimaryCard.Row>
                            <PrimaryCard.Row label="Change Requests">{data?.changeRequests}</PrimaryCard.Row>
                            <PrimaryCard.Row label="Cases">{data?.cases}</PrimaryCard.Row>
                            <PrimaryCard.Row label="Products">{data?.products}</PrimaryCard.Row>
                            <PrimaryCard.Row label="Projects">{data?.projects}</PrimaryCard.Row>
                            <PrimaryCard.Row label="CM Projects">{data?.cmProjects}</PrimaryCard.Row>
                            <PrimaryCard.Row label="AM Projects">{data?.amProjects}</PrimaryCard.Row>
                            <PrimaryCard.Row label="QM Projects">{data?.qmProjects}</PrimaryCard.Row>
                            <PrimaryCard.Row label="Sales Projects">{data?.salesProjects}</PrimaryCard.Row>
                        </>
                    )}
                </PrimaryCard>
                <PrimaryCard title="Unique Visit data" loading={!visit}>
                    {() => (
                        <>
                            <PrimaryCard.Row label="Today">{visit?.today}</PrimaryCard.Row>
                            <PrimaryCard.Row label="7 days">{visit?.last7Days}</PrimaryCard.Row>
                            <PrimaryCard.Row label="30 days">{visit?.last30Days}</PrimaryCard.Row>
                        </>
                    )}
                </PrimaryCard>
                <StatisticsSharedCards projectIds={[]} />
            </div>

            <FlatCard loading={!newProjects} title="Recently created projects">
                {() =>
                    newProjects!.length === 0 ? (
                        <p className={theme.projectMeta}>No projects created in the last 14 days.</p>
                    ) : (
                        <ul className={theme.projectList}>
                            {newProjects!.map((project) => (
                                <li key={project.id}>
                                    <CustomLink to={`/projects/${project.id}`}>{project.name}</CustomLink>
                                    <div className={theme.projectMeta}>
                                        {project.numberOfUnits} units ·{' '}
                                        <CustomLink to={`/profiles/${project.sellerProfile.id}`}>
                                            {project.sellerProfile.name}
                                        </CustomLink>
                                        {project.createDate && (
                                            <>
                                                {' '}
                                                · <DateDistanceDisplay value={project.createDate} />
                                            </>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )
                }
            </FlatCard>
        </div>
    );
};

export default BygrStatisticsDashboard;
